const dataExport = {
  export: 'Exportar',
  errorMessage: 'A exportação de dados encontrou erros inesperados.',
  waitForDownloadMessage: 'Solicitação enviada, o download começará em breve.',
  exportToCsv: {
    title: 'Exportar CSV',
    body: 'Você está prestes a exportar um arquivo CSV para {{selectedCount}} {{itemsLabel}}.'
  },
};

export default dataExport;
